import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";

function formatDate(d) {
    if (!d) return "";
    try {
        return new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
    } catch {
        return d;
    }
}

export default function Berita({ news }) {
    const { t } = useLang();
    const [featured, ...rest] = news;

    return (
        <section id="berita" className="py-24 md:py-32 border-t border-racing-line" data-testid="berita-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="01" title={t.ch_berita_t} subtitle={t.ch_berita_s} />

                {news.length === 0 ? (
                    <p className="text-racing-muted" data-testid="berita-empty">{t.berita_empty}</p>
                ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
                        {featured && (
                            <Reveal>
                                <Link to={`/berita/${featured.id}`} className="group block" data-testid="berita-featured">
                                    <div className="relative overflow-hidden">
                                        <img
                                            src={fileUrl(featured.image_url)}
                                            alt={featured.title}
                                            className="w-full h-[300px] md:h-[380px] object-cover transition-transform duration-700 group-hover:scale-105"
                                            style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 92% 100%, 0 100%)" }}
                                        />
                                        <span className="absolute top-4 left-4 bg-racing-red text-neutral-900 text-[10px] uppercase tracking-[0.25em] px-3 py-1.5">
                                            {featured.category}
                                        </span>
                                    </div>
                                    <p className="mt-6 text-xs uppercase tracking-[0.2em] text-racing-muted">{formatDate(featured.date)}</p>
                                    <h3 className="mt-3 font-display uppercase text-2xl md:text-4xl leading-tight text-neutral-900 group-hover:text-racing-red transition-colors duration-300">
                                        {featured.title}
                                    </h3>
                                    <p className="mt-4 text-sm md:text-base font-light text-racing-muted leading-relaxed">{featured.excerpt}</p>
                                    <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-neutral-900">
                                        {t.berita_read}
                                        <ArrowUpRight size={16} weight="bold" className="text-racing-red transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                                    </span>
                                </Link>
                            </Reveal>
                        )}

                        <div className="flex flex-col">
                            {rest.map((n, i) => (
                                <Reveal key={n.id} delay={i * 0.08}>
                                    <Link
                                        to={`/berita/${n.id}`}
                                        data-testid={`berita-item-${i}`}
                                        className="group flex items-start justify-between gap-6 py-7 border-b border-racing-line first:pt-0 hover:bg-black/[0.03] transition-colors duration-300 px-2 -mx-2"
                                    >
                                        <div>
                                            <p className="text-[10px] uppercase tracking-[0.25em] text-racing-muted">
                                                {n.category} · {formatDate(n.date)}
                                            </p>
                                            <h4 className="mt-2 font-display uppercase text-lg md:text-xl text-neutral-900/90 leading-snug group-hover:text-racing-red transition-colors duration-300">
                                                {n.title}
                                            </h4>
                                            <p className="mt-2 text-sm font-light text-racing-muted line-clamp-2">{n.excerpt}</p>
                                        </div>
                                        <ArrowUpRight size={22} weight="bold" className="shrink-0 mt-1 text-racing-muted group-hover:text-racing-red transition-colors duration-300" />
                                    </Link>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
